module.exports = __webpack_public_path__ + "img/down.beb5587e.png";